import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadSimpleIcon } from '@fronton/icons-react';
import {
  ButtonWithGAClickButton,
  PriceMediaCard,
  PriceMediaCardContent,
  PriceMediaCardDescription,
  PriceMediaCardSwiper,
  PriceMediaCardTitle,
  Section,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import { formatToRub } from 'utils/format';
import {
  lastProjectsGrid,
  lastProjectsText,
  projectButton,
  projectPrice,
} from './bathroom-repair-last-projects-styles';
import { BATHROOM_REPAIR_LAST_PROJECTS_DATA } from './bathroom-repair-last-projects-constants';
import { BATHROOM_REPAIR_CDN_PATH, BATHROOM_REPAIR_ELEMENT_BLOCK } from '../../bathroom-repair-constants';

export const BathroomRepairLastProjects: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionSubTitle adaptiveMargin margin="s">
        {t('last-projects.title')}
      </SectionSubTitle>
      <Typography className={lastProjectsText} variant="l" size="body_long">
        {t('last-projects.description')}
      </Typography>
      <ul className={lastProjectsGrid}>
        {BATHROOM_REPAIR_LAST_PROJECTS_DATA.map((project, index) => (
          <li key={createElementKey('project', index)}>
            <PriceMediaCard>
              <PriceMediaCardSwiper
                keyName="project-photo"
                landingCdn={BATHROOM_REPAIR_CDN_PATH}
                photosName={t(project.title)}
                photosSrc={project.images}
              />
              <PriceMediaCardContent>
                <PriceMediaCardTitle>{t(project.title)}</PriceMediaCardTitle>
                <PriceMediaCardDescription description={t(project.date)} />
                <Typography variant="caption_accent">
                  <span className={projectPrice}>{formatToRub(project.price)} </span>₽
                </Typography>
                <ButtonWithGAClickButton
                  className={projectButton}
                  iconLeft={<DownloadSimpleIcon type="outline" size="l" color="text-primary" />}
                  variant="secondary"
                  size="m"
                  wide
                  adaptive={false}
                  elementBlock={BATHROOM_REPAIR_ELEMENT_BLOCK}
                  elementName={`${t(project.title)} / ${t('last-projects.button-name')}`}
                  elementText={t('last-projects.title')}
                  href={project.link}
                  title={t(project.linkTitle) || ''}
                  target="_blank">
                  {t('last-projects.button-name')}
                </ButtonWithGAClickButton>
              </PriceMediaCardContent>
            </PriceMediaCard>
          </li>
        ))}
      </ul>
    </Section>
  );
};
